import SiteHeader from '../../features/headers/site-header';
import SiteFooter from '../../features/footer/site-footer';
import Landing from '../../features/landing/layouts/landing';

export default function HomePage() {
    return (
        <>
            <a className="skip-link" href="#contenido">Saltar al contenido</a>
            <SiteHeader />
            <main id="contenido">
                <Landing />
            </main>
            <SiteFooter />
        </>
    );
}
